module.exports = __webpack_public_path__ + "static/media/nicole_galloway_avatar.f93f77a8.jpg";